import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ToggleSection from './ToggleSection';

class Accordion extends Component {
  static displayName = 'Accordion';

  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        header: PropTypes.node,
        content: PropTypes.node,
      })
    ).isRequired,
    initiallyOpen: PropTypes.number,
    className: PropTypes.string,
  };

  state = {
    open:
      typeof this.props.initiallyOpen === 'number'
        ? this.props.initiallyOpen
        : false,
  };

  toggle(open) {
    this.setState({ open });
  }

  toggleSections() {
    return this.props.items.map((item, index) => {
      const toggle = open => {
        if (open) {
          this.toggle(index);
        } else {
          this.toggle(false);
        }
      };
      const open = index === this.state.open;
      return (
        <ToggleSection
          key={index}
          header={item.header}
          open={open}
          slave
          update={toggle}
        >
          {item.content}
        </ToggleSection>
      );
    });
  }

  render() {
    return (
      <section className={this.props.className}>
        {this.toggleSections()}
      </section>
    );
  }
}

export default Accordion;
